<template>
  <div>
    <post-item v-for="item in posts" :post="item" :key="item.id" @reloadPosts="loadPosts" />
    <div
      v-if="page != meta.last_page"
      @click="seeMore"
      class="row col-12 text-black-50 my-3 see-more d-flex justify-content-center"
    >
      <small>Ver Mais</small>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import PostItem from './../Post/Item'
import { mapGetters } from 'vuex'

export default {
  components: {
    "post-item": PostItem
  },
  data () {
    return {
      page: 1,
      meta: {},
      posts: [],
    }
  },
  computed: {
    ...mapGetters({
      user: 'getCurrentUser'
    })
  },
  methods: {
    seeMore: function () {
      this.page += 1
      this.loadPosts( this.page, true )
    },

    loadPosts: function ( page=1, concat=false ) {
      Axios.get('/posts', {
        params:{
          user: this.user.id,
          page: page,
        }
      })
        .then( res => {
          if ( concat ) this.posts.push( ...res.data.data )
          else this.posts = res.data.data

          this.meta = res.data.meta
        })
        .catch( err => {
          console.error( err )
        })
    }
  },
  mounted () {
    this.loadPosts()
  }
}
</script>
